module.exports = __webpack_public_path__ + "static/img/liveImgDemo.6cf989ef.jpg";